<template>
    <div>
        <div class="page-title">Setting</div>
        <div class="page-box">
            <el-tabs v-model="activeName">
                <el-tab-pane label="Basic Setting" name="first"></el-tab-pane>
                <el-tab-pane label="Payment" name="second"></el-tab-pane>
                <el-tab-pane label="Poor Student Application Note" name="third"></el-tab-pane>
                <el-tab-pane label="Application Template Label List" name="fourth"></el-tab-pane>
            </el-tabs>
            <basicSetting v-show="activeName == 'first'" :form="form"></basicSetting>
            <payment v-if="activeName == 'second'" :form="form"></payment>
            <poorStudentApplicationNote v-if="activeName == 'third'" :form="form"></poorStudentApplicationNote>
            <applicationTemplateLabelList v-show="activeName == 'fourth'" :form="form"></applicationTemplateLabelList>
            <el-button type="warning" v-show="activeName !== 'fourth'" @click="onSubmit">Submit</el-button>
        </div>
    </div>
</template> 

<script>
    import basicSetting from './components/basicSetting.vue'
    import payment from './components/payment.vue'
    import applicationTemplateLabelList from './components/applicationTemplateLabelList.vue'
    import poorStudentApplicationNote from './components/poorStudentApplicationNote.vue'
    import {getSetting,putSetting} from '@/api/admin/setting'
    export default {
        components:{basicSetting,payment,poorStudentApplicationNote,applicationTemplateLabelList},
        data() {
            return {
                activeName:'first',
                form: {
                    backgroundImage1: null, 
                    backgroundImage2: null, 
                    isEnableAccountRegistration: true, 
                    isEnableAutoSendAnnouncementAndEmail: true, 
                    paymentTemplateContent:'',
                    poorStudentApplicationNote:'',
                }
            }
        },
        created(){
            this.getSetting()
        },
        methods:{
           
            getSetting(){
                getSetting().then((v)=>{
                    this.form = v.data
                })
            },
            onSubmit(){
                this.putSetting()
            },
            putSetting(){
               putSetting(this.form.id,this.form).then(()=>{
                   this.$message.success('Set successfully')
                   this.getSetting()
               })
            }
           
        }
    }
</script>

<style lang="scss" scoped>
.page-box{
    background-color: #fff;
    padding: 30px;
}
</style>